// extracted by mini-css-extract-plugin
export default {"option":"ListOptionQuiz_option__bOcuQ"};